import { useMemo } from "react";
import ChartCanvas from "components/ChartCanvas";
import { genderEnum } from "enums/genders";
import customersService from "services/admin/customersService";
import { formatNumber, useDashboardQuery } from "../dashboard-utils";
import ChartCard from "./ChartCard";
import { pieOptions } from "./chartOptions";

const OPTIONS = pieOptions(formatNumber);
const GENDER_COLORS = { M: "#0EA5E9", F: "#EC4899" };

const CustomerGenders = () => {
  const q = useDashboardQuery(["customer-genders"], async () => (await customersService.getCustomersGenders()).data);

  const rows = useMemo(() => (Array.isArray(q.data) ? q.data.filter((r) => r?.gender) : []), [q.data]);
  const chartData = useMemo(
    () => ({
      labels: rows.map((r) => genderEnum[r.gender] || r.gender),
      datasets: [
        {
          label: "Клиенты",
          data: rows.map((r) => Number(r.total)),
          backgroundColor: rows.map((r) => GENDER_COLORS[r.gender] || "#94A3B8"),
          borderWidth: 0,
          spacing: 2,
        },
      ],
    }),
    [rows]
  );

  return (
    <ChartCard
      title="Клиенты по полу"
      periodLabel="За всё время"
      loading={q.isLoading}
      error={q.error}
      onRetry={q.refetch}
      empty={rows.length === 0}
      emptyText="Нет данных"
    >
      <ChartCanvas type="doughnut" data={chartData} options={OPTIONS} height={280} />
    </ChartCard>
  );
};

export default CustomerGenders;
